import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface UIState {
  currentPanel: number;
}

const initialState: UIState = {
  currentPanel: 0,
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setCurrentPanel: (state, action: PayloadAction<number>) => {
      state.currentPanel = action.payload;
    },
  },
});

export const { setCurrentPanel } = uiSlice.actions;
export default uiSlice.reducer;